import { BaseRouteService } from "core/services";

class FacilityOrderTemplateItemRouteService extends BaseRouteService {
	constructor() {
		super("facility-order-template-items");	
	}	

	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,pickTicketDetailId}`, filter);
	}
	
	batchCreate(resource) {		
		return super.batchCreate(`${this.base}/batch`, resource);	
	}

	createAdditionalItems(resource) {
		return super.batchCreate(`${this.base}/additional-items`, resource);	
	}

	createAdditionalItemsNewFlow(resource) {
		return super.batchCreate(`${this.base}/additional-items-new-flow`, resource);	
	}

	createAdditionalTrachItemsNewFlow(resource) {
		return super.batchCreate(`${this.base}/additional-trach-items-new-flow`, resource);	
	}
	
	calculateQuantity(resource) {
		return super.batchUpdate(`${this.base}/{id}/calculate-quantity{?changedValue,itemMlph,frequency,itemCals,itemMls}`, resource);	
	}

	calculateQuantityNewFlow(resource) {
		return super.batchUpdate(`${this.base}/calculate-quantity-new-flow{?facilityOrderId,productId,facilityOrderTemplateId,importReferenceId,changedValue,itemMlph,frequency,itemCals,itemMls,templateQuantity,orderQuantity}`, resource);	
	}

	recalculateQuantityNewFlow(resource) {
		return super.batchUpdate(`${this.base}/recalculate-quantity-new-flow{?facilityOrderId,productId,importReferenceId,itemMlph,frequency,itemCals,itemMls,templateQuantity,orderQuantity}`, resource);	
	}

	update(resource) {
        return super.update(this.base + '/{id}', resource);
    }	

	newUpdate(resource) {
        return super.update(this.base + '/new/{id}', resource);
    }	

	newFlowUpdate(resource) {
        return super.update(this.base + '/new-flow/{id}', resource);
    }	

	newDelete(resource) {
        return super.delete(this.base + '/new/{id}', resource);
    }

	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}

	batchUpdateSendSeparatelyQty(resource){
		return super.batchUpdate(`${this.base}/batch-update-send-separately-qty`, resource);	
	}

	findAndReplaceItem(resource) {
		return super.update(`${this.base}/find-and-replace-item`, resource);	
	}
	
	findAndDeleteItem(resource) {
		return super.update(`${this.base}/find-and-delete-item`, resource);	
	}

	calculateReplacementItemsQuantity(resource){
		return super.batchUpdate(`${this.base}/calculate-replacement-items-quantity`, resource);	
	}

	getOrderSummaryItems(filter) {
		return super.find(`${this.base}/order-summary/{?facilityOrderId,itemCategoryId,productId}`, filter);
	}

	cutbackSalesOrderQuantities(resource) {
		return super.update(`${this.base}/cutback-sales-order-quantities`, resource);	
	}

	updateSendSeparatelyQuantity(resource) {
		return super.update(`${this.base}/update-send-separately-quantity`, resource);	
	}	

	updateBatchSendSeparatelyQuantity(resource) {
		return super.update(`${this.base}/update-send-separately-quantity/batch-distribution`, resource);	
	}	
	
	roundToTheNearestCase(resource) {
		return super.update(`${this.base}/round-to-the-nearest-case/{?facilityOrderId,productId}`, resource);
	}

	updateIncludeNotCurrentTube(resource){
		return super.batchUpdate(`${this.base}/batch-update-include-not-current-tube`, resource);	
	}
}

export default FacilityOrderTemplateItemRouteService;
